import { Link } from "react-router-dom";

const footerNav = [
  { to: "/", label: "首页" },
  { to: "/category", label: "题材分类" },
  { to: "/rankings", label: "实时榜单" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

const categoryLinks = ["校园", "职场", "奇幻", "恋爱", "剧情"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-base text-background-50">
                <i className="ri-book-open-line" aria-hidden="true"></i>
              </span>
              <span className="font-display text-lg font-black tracking-wide text-foreground-950">
                羞羞漫画<span className="text-primary-500">韩国</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注韩国漫画的内容推荐平台，涵盖校园、职场、奇幻、恋爱、剧情等热门题材，用实时榜单帮你快速找到想看的作品。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-wide text-foreground-950">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-wide text-foreground-950">热门题材</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categoryLinks.map((c) => (
                <li key={c}>
                  <Link
                    to={`/category?type=${encodeURIComponent(c)}`}
                    className="inline-flex items-center gap-1.5 rounded-md bg-background-200/70 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                  >
                    <i className="ri-hashtag text-xs" aria-hidden="true"></i>
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-wide text-foreground-950">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" aria-hidden="true"></i>
                hi@manhwa.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500" aria-hidden="true"></i>
                内容合作 · 每周一至周五
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-smile-line text-primary-500" aria-hidden="true"></i>
                欢迎漫友投稿推荐
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 羞羞漫画韩国 · 仅供内容展示与爱好者交流
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="transition-colors hover:text-primary-600">
              关于我们
            </Link>
            <Link to="/contact" className="transition-colors hover:text-primary-600">
              联系我们
            </Link>
            <Link to="/faq" className="transition-colors hover:text-primary-600">
              常见问题
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}